
















import Vue from 'vue';
import HAvatar from '@/ui/components/base/HAvatar.vue';

export default Vue.extend({
  name: 'ReviewCommentText',
  components: {
    HAvatar,
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
});
